import React, { useEffect, useState } from 'react';
import { SearchIcon } from '@heroicons/react/outline';
import {
  Alert,
  Backdrop,
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  IconButton,
  InputAdornment,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';
import DataTable from '../UIElements/DataTable';

import ModalDialog from '../UIElements/ModalDialog';
import { HiOutlineUsers } from 'react-icons/hi2';
import BulkUpload from './BulkUpload';
import { BiEdit } from 'react-icons/bi';
import StudentFeeDetails from '../../pages/[admin]/Student/StudentFeeDetails';
import Tooltip from '@mui/material/Tooltip';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import {
  deleteStudentById,
  getStudentsList,
} from '../../features/student/studentSlice'; //For studetns data
import { getClasses } from '../../features/classes/ClassSlice';
import AddStudent from './AddStudent';
import ViewStudent from './ViewStudent';
import EditStudent from './EditStudent';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import api from '../../services/api';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SyncIcon from '@mui/icons-material/Sync';
import { MenuProps } from '../../utils/constants';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useLocation } from 'react-router-dom';
const StudentsList = () => {
  const dispatch = useDispatch();
  //const { studentsList,totalRecords} = useSelector((state) => state.students.studentsData);
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  const location = useLocation();
  //const navigate = useNavigate();
  const [studentId, setStudentId] = useState(null);
  const [studentsDetails, setStudentsDetails] = useState([]);
  const [addStudent, setAddStudent] = useState(false); // ==============================
  const [editStudent, setEditStudent] = useState(false); //   All
  const [viewStudent, setViewStudent] = useState(false); //           are
  const [uploadStudents, setUploadStudents] = useState(false); //              for
  const [viewFees, setViewFees] = useState(false); //                                  opening
  const [editModal, setEditModal] = useState(false); //Pre Edit-Modal
  const [deleteModal, setDeleteModal] = useState(false); //Pre Delete-Modal                                  Modals ===========
  const [isDownloading, setIsDownloading] = useState(false);
  const [searchableCLasses, setSearchableClasses] = useState([]); // list of Classes
  const [searchParameters, setSearchParameters] = useState({
    feeType: '',
    department: '',
    search: '',
    column: '',
    operator: '',
    value: '',
    instituteType: instituteType,
    pageNumber: 0,
    pageSize: 10,
  }); //search Parameters and pageSize adn pageOptions
  const [loading, setLoading] = useState(false);
  const [downloadError, setDownloadError] = useState(false);
  const { userDetails, userPermissions } = useSelector(
    (state) => state.auth?.successData ?? {},
  );
  let TableClassHeader = '';
  let customColumns = [];
  if (instituteType?.toLowerCase() === 'school') {
    TableClassHeader = 'Class ';
    customColumns = [
      {
        field: 'departmentName',
        headerName: <div className='text-sm'>Class</div>,
        flex: 1,
        headerClassName: 'bold-header',
        renderCell: (param) => (
          <div className='text-[14px] cursor-default '>{param.value}</div>
        ),
      },
      {
        field: 'className',
        headerName: <div className='text-sm'>Section</div>,
        flex: 1,
        headerClassName: 'bold-header',
        renderCell: (param) => (
          <div className='text-[14px] cursor-default '>{param.value}</div>
        ),
      },
    ];
  } else if (instituteType?.toLowerCase() === 'college') {
    TableClassHeader = 'Department ';
    customColumns = [
      {
        field: 'departmentName',
        headerName: <div className='text-sm'>Department</div>,
        flex: 1,
        headerClassName: 'bold-header',
        renderCell: (param) => (
          <div className='text-[14px] cursor-default '>{param.value}</div>
        ),
      },
      {
        field: 'className',
        headerName: <div className='text-sm'>Branch</div>,
        flex: 1,
        headerClassName: 'bold-header',
        renderCell: (param) => (
          <div className='text-[14px] cursor-default '>{param.value}</div>
        ),
      },
      {
        field: 'sectionName',
        headerName: <div className='text-sm'>Year </div>,
        flex: 1,
        headerClassName: 'bold-header',
        renderCell: (param) => (
          <div className='text-[14px] cursor-default '>{param.value}</div>
        ),
      },
    ];
  } else {
    TableClassHeader = 'Department ';
    customColumns = [
      {
        field: 'departmentName',
        headerName: <div className='text-sm'>Department</div>,
        flex: 1,
        headerClassName: 'bold-header',
        renderCell: (param) => (
          <div className='text-[14px] cursor-default '>{param.value}</div>
        ),
      },
      {
        field: 'className',
        headerName: <div className='text-sm'>Class/Section</div>,
        flex: 1,
        headerClassName: 'bold-header',
        renderCell: (param) => (
          <div className='text-[14px] cursor-default '>{param.value}</div>
        ),
      },
    ];
  }
  async function getStudents(data) {
    setLoading(true);
    try {
      const response = await dispatch(getStudentsList(data)).unwrap();
      setStudentsDetails(response);
    } catch {
      console.log('Error occured in Getting Students');
    } finally {
      setLoading(false);
    }
  }
  async function getClassesList() {
    const list = await dispatch(getClasses()).unwrap();
    setSearchableClasses(findClasses(list));
  }
  useEffect(() => {
    getStudents(searchParameters);
    getClassesList();
  }, [searchParameters]);

  useEffect(() => {
    if (location?.state?.openStudentAdd)
      setAddStudent(location?.state?.openStudentAdd ?? false);
    // Clear the state from history
    window.history.replaceState({}, '', location.pathname);
  }, []);
  //Finding the list of classes
  function findClasses(list) {
    try {
      var options = [];
      if (list?.length > 0) {
        for (const a of list) {
          options.push(a?.department);
        }
      }
      return [...new Set(options)];
    } catch (error) {
      console.log(error);
    }
  }

  const columns = [
    {
      field: 'studentId',
      headerName: <div className='text-sm'>Student Id</div>,
      flex: 1,
      renderCell: (param) => (
        <Button
          disableRipple
          variant='text'
          className='text-[#2f57ef] hover:bg-white normal-case'
          onClick={() => {
            setStudentId(param.row?.studentId);
            setViewStudent(true);
          }}
        >
          {param.value}
        </Button>
      ),
    },
    {
      field: 'firstName',
      headerName: <div className='text-sm'>First Name</div>,
      flex: 1,
      headerClassName: 'bold-header',
      renderCell: (param) => (
        <div className='text-[14px] cursor-default truncate'>{param.value}</div>
      ),
    },
    {
      field: 'lastName',
      headerName: <div className='text-sm'>Last Name</div>,
      flex: 1,
      renderCell: (param) => (
        <div className='text-[14px] cursor-default truncate'>{param.value}</div>
      ),
    },
    {
      field: 'mobileNumber',
      headerName: <div className='text-sm'>Mobile Number</div>,
      flex: 1,
      renderCell: (param) => (
        <div className='text-[14px] cursor-default '>{param.value}</div>
      ),
    },
    ...customColumns,
    {
      field: 'actions',
      headerName: <div className='text-sm'>Action</div>,
      flex: 1,
      renderCell: (param) => (
        <Box className='flex gap-2'>
          <Tooltip title='View' placement='left'>
            <IconButton
              size='small'
              className=' rounded '
              variant='outlined'
              onClick={() => {
                setStudentId(param.row?.studentId);
                setViewStudent(true);
              }}
            >
              <TableEye />
            </IconButton>
          </Tooltip>
          {userDetails && userPermissions?.studentManagement && (
            <Tooltip title='Edit' placement='top'>
              <IconButton
                size='small'
                className='text-blue-500 '
                variant='outlined'
                onClick={() => {
                  setStudentId(param.row?.studentId);
                  setEditModal(true);
                }}
              >
                <BiEdit className='size-6' />
              </IconButton>
            </Tooltip>
          )}
          {/* Delete Icon Code */}
          {userDetails && userDetails?.role?.toLowerCase() === 'admin' && (
            <Tooltip title='Delete' placement='top'>
              <IconButton
                size='small'
                className='text-red-400 rounded'
                variant='outlined'
                onClick={() => {
                  setStudentId(param.row?.id);
                  setDeleteModal(true);
                }}
              >
                <DeleteForeverIcon />
              </IconButton>
            </Tooltip>
          )}

          {userDetails && userPermissions?.payments && (
            <Tooltip title='Payment Details' placement='right'>
              <IconButton
                size='small'
                className=''
                variant='outlined'
                onClick={() => {
                  setStudentId(param.row?.studentId);
                  setViewFees(true);
                }}
              >
                <MoneyIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      ),
    },
  ];
  async function downloadStudents(searchParameters) {
    //console.log(Students);
    try {
      const fileResponse = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/students/downloadResult',
        method: 'POST',
        responseType: 'blob',
        headers: searchParameters,
      });
      const blob = new Blob([fileResponse?.data], {
        type: fileResponse.headers['content-type'],
      });

      let filename = 'Students.xlsx';
      const contentDisposition = fileResponse?.headers['content-disposition'];
      const match = contentDisposition?.match(/filename="?(.+)"?/);

      if (match?.[1]) filename = match[1];

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(url);
      setIsDownloading(false);
    } catch (err) {
      setDownloadError(true);
      setIsDownloading(false);
      alert('Error in Downloading');
      console.error('Download failed', err);
    }
  }
  return (
    <div className=' pt-3  min-[300px]:px-2 min-md:px-4 lg:px-6 bg-[#EFF6FF] h-full flex flex-col'>
      <Snackbar
        open={downloadError}
        autoHideDuration={3000}
        onClose={() => {
          setDownloadError(false);
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={() => {
            setDownloadError(false);
          }}
          severity='error'
          variant='filled'
          sx={{ width: '100%' }}
        >
          There is an Error in Downloading the Students!
        </Alert>
      </Snackbar>
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={isDownloading}
      >
        <div>
          <div className='text-center'>
            <CircularProgress color='inherit' />
          </div>
          <div className='text-center'>Downloading ..</div>
          <div className='text-center'>{downloadError}</div>
        </div>
      </Backdrop>
      {status === 'loading' ? (
        <div>Loading</div>
      ) : (
        <div>
          {/* First Row */}
          <div className='flex justify-between items-center flex-wrap '>
            <Typography variant='h6' color='primary' className='font-bold'>
              Students
            </Typography>
            <div className='flex gap-2  justify-start  items-center flex-wrap'>
              {/* Refresh Button */}
              <Tooltip title='Refresh' placement='bottom'>
                <div
                  className='flex items-center justify-center'
                  style={{
                    height: '39px',
                    width: '51px',
                    backgroundColor: '#fff',
                    color: '#515b73',
                    border: '1px solid #E9EDF4',
                    borderRadius: '5px',
                  }}
                  onClick={() =>
                    setSearchParameters({
                      feeType: '',
                      department: '',
                      search: '',
                      column: '',
                      operator: '',
                      value: '',
                      instituteType: instituteType,
                      pageNumber: 0,
                      pageSize: 10,
                    })
                  }
                >
                  <SyncIcon />
                </div>
              </Tooltip>

              {/* Upload Button */}
              {userDetails && userDetails?.role?.toLowerCase() === 'admin' && (
                <Tooltip title='Bulk Upload' placement='bottom'>
                  {' '}
                  <Button
                    variant='contained'
                    sx={{
                      width: '120px',
                      borderRadius: '5px',
                      backgroundColor: '#fff',
                      border: '1px solid #e9edf4',
                      color: '#515b73',
                    }}
                    onClick={() => setUploadStudents(true)}
                    startIcon={<HiOutlineUsers />}
                    className='normal-case text-[14px] shadow-none'
                  >
                    Upload
                  </Button>
                </Tooltip>
              )}

              {/* Download Button */}
              <Tooltip title='Download Students' placement='bottom'>
                {' '}
                <Button
                  disabled={studentsDetails?.students?.length === 0}
                  variant='contained'
                  sx={{
                    width: '120px',
                    backgroundColor: '#e9edf4',
                    color: '#515b73',
                    border: '1px solid #e9edf4',
                  }}
                  onClick={() => {
                    setIsDownloading(true);
                    downloadStudents(searchParameters);
                  }}
                  startIcon={
                    <FileDownloadIcon className='animate-bounce pt-[6px]  pb-0 size-6' />
                  }
                  className='normal-case text-[14px] shadow-none'
                >
                  Download
                </Button>
              </Tooltip>

              {/* Add BUTTON */}
              {userDetails && userDetails?.role?.toLowerCase() === 'admin' && (
                <Tooltip title='Add Student' placement='bottom'>
                  <Button
                    variant='contained'
                    onClick={() => setAddStudent(true)}
                    startIcon={<AddCircleIcon />}
                    className='normal-case text-[14px] shadow-none'
                  >
                    Add Student
                  </Button>
                </Tooltip>
              )}
            </div>
          </div>
          {/* Second Row */}
          <div className=' bg-white gap-2 px-2 py-3 mt-3'>
            {/* Reset Filter Chip */}
            <div className='flex items-center gap-2'>
              <Typography variant='body1' className='font-semibold'>
                Selected Students :{studentsDetails?.totalRecords}
              </Typography>
              {(searchParameters.feeType ||
                searchParameters.department ||
                searchParameters.value ||
                searchParameters.search) &&
                studentsDetails && (
                  <Chip
                    className=' bg-orange-200'
                    label='Reset Filters'
                    onClick={() => {
                      setSearchParameters((prev) => ({
                        ...prev,
                        feeType: '',
                        department: '',
                        search: '',
                        instituteType: instituteType,
                        pageNumber: 0,
                        pageSize: 10,
                        column: '',
                        operator: '',
                        value: '',
                      }));
                    }}
                  >
                    Reset Filters
                  </Chip>
                )}
            </div>
            {/* Select Grade,Search TextField and Select Fee Type */}
            <div className='flex justify-between items-start  mt-2 flex-wrap '>
              <div className='flex gap-2 items-end flex-wrap max-sm:w-full mb-2 '>
                <TextField
                  className='w-[200px] md:w-[250px]'
                  size='small'
                  placeholder='Search by Id, Name, Class'
                  value={searchParameters?.search}
                  variant='outlined'
                  onChange={(e) => {
                    getStudents({
                      ...searchParameters,
                      search: e.target.value,
                    });
                    setSearchParameters((prev) => ({
                      ...prev,
                      search: e.target.value,
                    }));
                  }}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment position='end'>
                          <SearchIcon className='size-5 text-gray-600' />
                        </InputAdornment>
                      ),
                    },
                  }}
                />{' '}
                <FormControl size='small'>
                  <InputLabel id='class'>{`Select ${TableClassHeader}`}</InputLabel>
                  <Select
                    fullWidth
                    MenuProps={MenuProps}
                    labelId='class'
                    id='demo-simple-select'
                    className='w-[200px]  '
                    value={searchParameters?.department}
                    label={`Select ${TableClassHeader}`}
                    onChange={(e) => {
                      getStudents({
                        ...searchParameters,
                        department: e.target.value,
                      });
                      setSearchParameters((prev) => ({
                        ...prev,
                        department: e.target.value,
                      }));
                    }}
                  >
                    {searchableCLasses.length > 0 ? (
                      <MenuItem value='all'>Select All</MenuItem>
                    ) : (
                      <MenuItem>No Classes</MenuItem>
                    )}
                    {searchableCLasses?.map((item, index) => (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              <FormControl size='small'>
                <InputLabel id='FeeDue'>Fee Due Type</InputLabel>
                <Select
                  MenuProps={MenuProps}
                  size='small'
                  labelId='Fee Due'
                  id='demo-simple-select'
                  className='w-[200px] '
                  value={searchParameters?.feeType}
                  label='FeeDue Type'
                  onChange={(e) => {
                    getStudents({
                      ...searchParameters,
                      feeType: e.target.value,
                    });
                    setSearchParameters((prev) => ({
                      ...prev,
                      feeType: e.target.value,
                    }));
                  }}
                >
                  <MenuItem value='all'>Select All</MenuItem>
                  <MenuItem value='Due'>Fee Due</MenuItem>
                  <MenuItem value='NoDue'>No Due</MenuItem>
                  <MenuItem value='WriteOff'>Marked as No Due</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>

          <Box
            sx={{
              overflowX: 'scroll', // always show scrollbar
              whiteSpace: 'nowrap', // prevent wrapping
              '&::-webkit-scrollbar': {
                height: '4px', // customize scrollbar height
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#888',
              },
            }}
          >
            <div style={{ minWidth: '1200px' }}>
              <DataTable
                rows={studentsDetails?.students || []}
                columns={columns}
                rowCount={studentsDetails?.totalRecords || 0}
                paginationMode='server'
                page={searchParameters?.pageNumber}
                pageSize={searchParameters?.pageSize}
                loading={loading}
                onSortModelChange={(model) => {
                  var filter = {};
                  Object.entries(searchParameters).forEach(([key, value]) => {
                    if (key !== 'sortAsc' && key !== 'sortDesc') {
                      filter[key] = value;
                    }
                  });
                  if (model?.[0]?.sort === 'desc') {
                    filter['sortDesc'] = model?.[0]?.field;
                  }
                  if (model?.[0]?.sort === 'asc') {
                    filter['sortAsc'] = model?.[0]?.field;
                  }
                  setSearchParameters({ ...filter });
                  getStudents(filter);
                }}
                onPageChange={(e) => {
                  setSearchParameters((prev) => ({
                    ...prev,
                    pageNumber: e?.page,
                    pageSize: e?.pageSize,
                  }));
                  getStudents({
                    ...searchParameters,
                    pageNumber: e?.page,
                    pageSize: e?.pageSize,
                  });
                }}
                onFilterModelChange={(e) => {
                  // Debounce filter changes to avoid rapid API calls
                  if (e?.items[0]?.field) {
                    if (window._studentFilterDebounce) {
                      clearTimeout(window._studentFilterDebounce);
                    }
                    window._studentFilterDebounce = setTimeout(() => {
                      setSearchParameters((prev) => ({
                        ...prev,
                        column: e?.items[0]?.field,
                        operator: e?.items[0]?.operator,
                        value: e?.items[0]?.value,
                      }));
                      getStudents({
                        ...searchParameters,
                        column: e?.items[0]?.field,
                        operator: e?.items[0]?.operator,
                        value: e?.items[0]?.value,
                      });
                    }, 400);
                  }
                }}
              />
            </div>
          </Box>

          <div>
            {/* Add Student */}
            <ModalDialog
              size='lg'
              isOpen={addStudent}
              onClose={() => {
                setAddStudent(false);
              }}
              title='Add Student'
            >
              <AddStudent
                setAddStudent={setAddStudent}
                refreshStudents={() => getStudents(searchParameters)}
              />
            </ModalDialog>
            {/* Edit  Student   */}
            <Dialog
              fullWidth={true}
              maxWidth='lg'
              open={editStudent}
              onClose={() => setEditStudent(false)}
              aria-labelledby='modal-modal-title'
              aria-describedby='modal-modal-description'
            >
              <div className='m-4 overflow-auto '>
                <EditStudent
                  setEditStudent={setEditStudent}
                  StudentId={studentId}
                  setEditModal={setEditModal}
                  refreshStudents={() => getStudents(searchParameters)}
                />
              </div>
            </Dialog>
            {/* View Student */}
            <ModalDialog
              size='lg'
              isOpen={viewStudent}
              onClose={() => setViewStudent(false)}
              title={
                <span>
                  Student Details{' '}
                  <span className='text-blue-500'>({studentId})</span>
                </span>
              }
              footer={
                <Button
                  variant='contained'
                  onClick={() => setViewStudent(false)}
                  className='bg-blue-500 hover:bg-blue-600 text-white normal-case'
                >
                  Close
                </Button>
              }
            >
              {/* <ViewStudent candidateData={candidateData} /> */}
              <ViewStudent StudentId={studentId} />
            </ModalDialog>
            {/* Bulk Upload */}
            <ModalDialog
              size='sm'
              isOpen={uploadStudents}
              onClose={() => {
                setUploadStudents(false);
              }}
              title='Bulk Upload Students'
              aria-labelledby='modal-modal-title'
              aria-describedby='modal-modal-description'
            >
              <BulkUpload
                refreshStudents={() => getStudents(searchParameters)}
                setUploadStudents={setUploadStudents}
              />
            </ModalDialog>
            {/* Fee Details */}
            <ModalDialog
              size='md'
              isOpen={viewFees}
              onClose={() => {
                setViewFees(false);
              }}
              footer={
                <Button
                  variant='contained'
                  onClick={() => setViewFees(false)}
                  className='bg-blue-500 hover:bg-blue-600 text-white normal-case'
                >
                  Close
                </Button>
              }
              title={
                <span>
                  Payment Details{' '}
                  <span className='text-blue-500'>({studentId})</span>
                </span>
              }
            >
              <StudentFeeDetails StudentId={studentId} />
            </ModalDialog>
            {/* PreEdit Modal */}
            <Dialog
              maxWidth='xs'
              open={editModal}
              onClose={() => setEditModal(false)}
            >
              <div className=''>
                <div className='flex justify-between bg-blue-200 p-3 rounded-t-md'>
                  <Typography variant='h5' className='text-indigo-700'>
                    Alert !
                  </Typography>
                  <CloseIcon
                    className='bg-stone-50 hover:bg-indigo-700 hover:text-white transition duration-700 rounded-md'
                    size='large'
                    onClick={() => {
                      setEditModal(false);
                    }}
                  />
                </div>

                <div className='py-10 px-4'>
                  <Typography variant='h6' textAlign={'center'}>
                    {' '}
                    Are you sure,you want to edit the details ?
                  </Typography>

                  <div className='flex justify-evenly mt-5'>
                    <Button
                      size='small'
                      variant='outlined'
                      onClick={() => setEditModal(false)}
                      className='font-semibold rounded-lg   py-2 px-6'
                    >
                      No
                    </Button>
                    <Button
                      size='small'
                      variant='contained'
                      onClick={() => {
                        setEditStudent(true);
                        setEditModal(false);
                      }}
                      className='normal-case text-base font-semibold rounded-lg text-white  py-2 px-6'
                      style={{
                        background:
                          'linear-gradient(90deg, #3b82f6 0%, #c084fc 100%)',
                      }}
                    >
                      EDIT
                    </Button>
                  </div>
                </div>
              </div>
            </Dialog>

            {/* PreDelete Modal */}
            <Dialog
              maxWidth='xs'
              fullWidth
              open={deleteModal}
              onClose={() => setDeleteModal(false)}
            >
              <div className=''>
                <div className='flex justify-between border-b p-3 rounded-t-md'>
                  <Typography variant='h5'>Alert !</Typography>
                  <CloseIcon
                    size='large'
                    onClick={() => {
                      setDeleteModal(false);
                    }}
                  />
                </div>

                <div className='py-10 px-4  text-center'>
                  <Typography variant='h6'>
                    {' '}
                    Are you sure,you want to delete ?
                  </Typography>
                  <Typography variant='body2' color='error' className='mt-1'>
                    {' '}
                    Note : Data will be deleted permanently.
                  </Typography>

                  <div className='flex justify-evenly mt-5'>
                    <Button
                      size='small'
                      variant='outlined'
                      color='error'
                      onClick={() => setDeleteModal(false)}
                      className='font-semibold rounded-lg   py-2 px-6'
                    >
                      No
                    </Button>
                    <Button
                      size='small'
                      variant='contained'
                      onClick={async () => {
                        try {
                          const response = await dispatch(
                            deleteStudentById(studentId),
                          ).unwrap();

                          if (response) {
                            getStudents(searchParameters);
                            setDeleteModal(false);
                          }
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                      className='normal-case text-base font-semibold rounded-lg text-white  py-2 px-6'
                      style={{
                        background:
                          'linear-gradient(90deg,#f72e14  0%, #e0a955 100%)',
                      }}
                    >
                      DELETE
                    </Button>
                  </div>
                </div>
              </div>
            </Dialog>
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentsList;
const TableEye = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={22}
    height={22}
    viewBox='0 0 22 22'
    fill='none'
  >
    <mask
      id='mask0_303_255'
      style={{ maskType: 'alpha' }}
      maskUnits='userSpaceOnUse'
      x={0}
      y={0}
      width={22}
      height={22}
    >
      <rect width={22} height={22} fill='#D9D9D9' />
    </mask>

    <g mask='url(#mask0_303_255)'>
      <path
        d='M4.9498 18.7C4.44564 18.7 4.0446 18.551 3.74668 18.2531C3.44876 17.9552 3.2998 17.5542 3.2998 17.05V4.94999C3.2998 4.44582 3.44876 4.04478 3.74668 3.74686C4.0446 3.44895 4.44564 3.29999 4.9498 3.29999H17.0498C17.554 3.29999 17.955 3.44895 18.2529 3.74686C18.5508 4.04478 18.6998 4.44513 18.6998 4.94792V12.5583C18.439 12.4193 18.1714 12.2929 17.897 12.1791C17.6225 12.0652 17.3401 11.9701 17.0498 11.8937V8.24999H11.8248V11.9396C11.2901 12.1076 10.7897 12.3177 10.3238 12.5698C9.85779 12.8219 9.41855 13.1236 9.00605 13.475H4.9498V17.05H6.43939C6.56161 17.3555 6.69911 17.642 6.85189 17.9094C7.00467 18.1767 7.16508 18.4403 7.33314 18.7H4.9498ZM4.9498 11.825H10.1748V8.24999H4.9498V11.825ZM4.9498 6.59999H17.0498V4.94999H4.9498V6.59999ZM14.5748 20.9C13.2151 20.9 11.9547 20.5677 10.7936 19.9031C9.63244 19.2385 8.78453 18.2875 8.2498 17.05C8.78453 15.8125 9.63244 14.8614 10.7936 14.1969C11.9547 13.5323 13.2151 13.2 14.5748 13.2C15.9345 13.2 17.1949 13.5323 18.3561 14.1969C19.5172 14.8614 20.3651 15.8125 20.8998 17.05C20.3651 18.2875 19.5172 19.2385 18.3561 19.9031C17.1949 20.5677 15.9345 20.9 14.5748 20.9ZM14.5748 19.25C15.4676 19.25 16.3096 19.0667 17.1007 18.7C17.8918 18.3333 18.5317 17.7833 19.0206 17.05C18.5317 16.3167 17.8918 15.7667 17.1007 15.4C16.3096 15.0333 15.4676 14.85 14.5748 14.85C13.682 14.85 12.84 15.0333 12.0489 15.4C11.2578 15.7667 10.6179 16.3167 10.129 17.05C10.6179 17.7833 11.2578 18.3333 12.0489 18.7C12.84 19.0667 13.682 19.25 14.5748 19.25ZM14.5748 18.425C14.1929 18.425 13.8682 18.2913 13.6008 18.0239C13.3335 17.7566 13.1998 17.4319 13.1998 17.05C13.1998 16.668 13.3335 16.3434 13.6008 16.076C13.8682 15.8087 14.1929 15.675 14.5748 15.675C14.9567 15.675 15.2814 15.8087 15.5488 16.076C15.8161 16.3434 15.9498 16.668 15.9498 17.05C15.9498 17.4319 15.8161 17.7566 15.5488 18.0239C15.2814 18.2913 14.9567 18.425 14.5748 18.425Z'
        fill='#5F6368'
      />
    </g>
  </svg>
);
const MoneyIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={22}
    height={22}
    viewBox='0 0 22 22'
    fill='none'
  >
    <mask
      id='mask0_303_101'
      style={{ maskType: 'alpha' }}
      maskUnits='userSpaceOnUse'
      x={0}
      y={0}
      width={22}
      height={22}
    >
      <rect width={22} height={22} fill='#D9D9D9' />
    </mask>

    <g mask='url(#mask0_303_101)'>
      <path
        d='M12.6501 12.1C11.8862 12.1 11.2369 11.8326 10.7022 11.2979C10.1675 10.7632 9.9001 10.1139 9.9001 9.34999C9.9001 8.58611 10.1675 7.9368 10.7022 7.40208C11.2369 6.86736 11.8862 6.59999 12.6501 6.59999C13.414 6.59999 14.0633 6.86736 14.598 7.40208C15.1327 7.9368 15.4001 8.58611 15.4001 9.34999C15.4001 10.1139 15.1327 10.7632 14.598 11.2979C14.0633 11.8326 13.414 12.1 12.6501 12.1ZM6.0501 14.3C5.59635 14.3 5.20791 14.1383 4.88478 13.8148C4.56166 13.4916 4.4001 13.1028 4.4001 12.6486V6.04358C4.4001 5.58952 4.56166 5.20208 4.88478 4.88124C5.20791 4.56041 5.59635 4.39999 6.0501 4.39999H19.2501C19.7038 4.39999 20.0923 4.56171 20.4154 4.88514C20.7385 5.20842 20.9001 5.59716 20.9001 6.05137V12.6564C20.9001 13.1105 20.7385 13.4979 20.4154 13.8187C20.0923 14.1396 19.7038 14.3 19.2501 14.3H6.0501ZM7.7001 12.65H17.6001C17.6001 12.1917 17.7617 11.8012 18.0848 11.4785C18.4079 11.156 18.7963 10.9947 19.2501 10.9947V7.69999C18.7963 7.69999 18.4079 7.53843 18.0848 7.21531C17.7617 6.89218 17.6001 6.50374 17.6001 6.04999H7.7001C7.7001 6.50833 7.53854 6.89883 7.21541 7.22149C6.89228 7.54401 6.50385 7.70526 6.0501 7.70526V11C6.50385 11 6.89228 11.1616 7.21541 11.4847C7.53854 11.8078 7.7001 12.1962 7.7001 12.65ZM18.1501 17.6H2.7501C2.29635 17.6 1.90791 17.4384 1.58479 17.1153C1.26166 16.7922 1.1001 16.4037 1.1001 15.95V6.59999H2.7501V15.95H18.1501V17.6Z'
        fill='#2E7D32'
      />
    </g>
  </svg>
);
